import { render, staticRenderFns } from "./PlayerMissedTurns.vue?vue&type=template&id=3952b684&scoped=true&"
import script from "./PlayerMissedTurns.vue?vue&type=script&lang=js&"
export * from "./PlayerMissedTurns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952b684",
  null
  
)

export default component.exports